// src/v2/pages/Reports/EmployeeContributionLedger.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useEmployeeContributionLedger } from '../../hooks/useEmployeeContributionLedger';
import { EmployeeContributionLedgerModule } from '../../components/modules/Reports/EmployeeContributionLedger/EmployeeContributionLedgerModule';

const EmployeeContributionLedger = ({ isHideSideMenu }) => {
  const reportHook = useEmployeeContributionLedger();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <EmployeeContributionLedgerModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default EmployeeContributionLedger;